import React, { useState } from "react";
import { useAuth } from "../Auth/AuthProvider";

export const Carrot = ({ isOpen }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="#393838"
      className={`${isOpen ? "rotate-180" : "carrot"}`}
    >
      <path
        d="M14.5736 2.44003L8.17357 8.84003C8.01357 9.00003 7.77357 9.08003 7.53357 9.08003C7.29357 9.08003 7.05357 9.00003 6.89357 8.84003L0.493573 2.44003C0.093573 2.04003 0.093573 1.48003 0.493573 1.08003C0.893573 0.680029 1.45357 0.680029 1.85357 1.08003L7.61357 6.84003L13.3736 1.08003C13.7736 0.680029 14.3336 0.680029 14.7336 1.08003C14.9736 1.48003 14.9736 2.12003 14.5736 2.44003Z"
        fill="#393838"
      />
    </svg>
  );
};

export const PencilIcon = ({ clickFunction }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
      onClick={clickFunction}
    >
      <path
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 000-1.42l-2.34-2.34a1.003 1.003 0 00-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"
        fill="#000"
      />
    </svg>
  );
};
export const ScannerIcon = ({ setScanner }) => {
  return (
    <svg
      onClick={setScanner}
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M3 4V6C3 7.1 3.9 8 5 8H7" />

      <path d="M17 8H19C20.1 8 21 7.1 21 6V4" />

      <path d="M3 20V18C3 16.9 3.9 16 5 16H7" />

      <path d="M17 16H19C20.1 16 21 16.9 21 18V20" />

      <path d="M7 12H17" stroke="red" />
    </svg>
  );
};

export const UsFlag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      className=""
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.57819 1.60001V2.56001V3.52001V4.48001V5.44001V6.40001V7.44001V8.40001H23.0582V7.52001H12.0982V8.48001V1.60001V2.56001H23.0582V1.60001V14.4V13.44H2.57819V14.4V1.60001ZM23.0582 3.52001V4.48001H12.0982V3.52001H23.0582ZM23.0582 5.52001V6.48001H12.0982V5.52001H23.0582ZM23.0582 9.44001V10.4H2.57819V9.44001H23.0582ZM23.0582 11.52V12.48H2.57819V11.52H23.0582Z"
        fill="white"
      />
      <path
        d="M12.0182 1.60001H2.49817V8.48001H12.0182V1.60001Z"
        fill="#19356A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.49817 13.44H22.9782V14.4H2.49817V13.44ZM12.0182 1.60001H22.9782V2.56001H12.0182V1.60001ZM22.9782 3.52001V4.48001H12.0182V3.52001H22.9782ZM22.9782 5.52001V6.48001H12.0182V5.52001H22.9782ZM22.9782 7.52001V8.48001H2.49817H12.0182V7.52001H22.9782ZM22.9782 9.44001V10.4H2.49817V9.44001H22.9782ZM22.9782 11.52V12.48H2.49817V11.52H22.9782Z"
        fill="#AD171A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.69818 2.64001L5.77818 2.88001H6.09818L5.85818 3.12001L5.93818 3.44001L5.69818 3.20001L5.37818 3.36001L5.45818 3.04001L5.21818 2.88001H5.53818L5.69818 2.64001ZM4.09818 2.64001L4.17818 2.88001H4.49818L4.25818 3.12001L4.33818 3.44001L4.09818 3.20001L3.85818 3.36001L3.93818 3.12001L3.69818 2.88001H4.01818L4.09818 2.64001ZM11.2982 7.28001L11.3782 7.52001H11.6982L11.4582 7.68001L11.5382 8.00001L11.2982 7.84001L11.0582 8.00001L11.1382 7.76001L10.8982 7.60001H11.2182L11.2982 7.28001ZM3.21818 7.28001L3.29818 7.52001H3.61818L3.45818 7.76001L3.53818 8.08001L3.21818 7.92001L2.97818 8.08001L3.05818 7.76001L2.81818 7.60001H3.13818L3.21818 7.28001ZM4.81818 7.28001L4.89818 7.52001H5.21818L4.97818 7.76001L5.05818 8.08001L4.81818 7.92001L4.57818 8.08001L4.65818 7.76001L4.41818 7.60001H4.73818L4.81818 7.28001ZM6.41818 7.28001L6.49818 7.52001H6.81818L6.65818 7.76001L6.73818 8.08001L6.41818 7.92001L6.17818 8.08001L6.25818 7.76001L6.01818 7.60001H6.33818L6.41818 7.28001ZM8.09818 7.28001L8.17818 7.52001H8.49818L8.25818 7.76001L8.33818 8.08001L8.09818 7.92001L7.85818 8.08001L7.93818 7.76001L7.69818 7.60001H8.01818L8.09818 7.28001ZM9.69818 7.28001L9.77818 7.52001H10.0982L9.85818 7.68001L9.93818 8.00001L9.69818 7.84001L9.45818 8.00001L9.53818 7.68001L9.29818 7.52001H9.61818L9.69818 7.28001ZM4.01818 6.64001L4.09818 6.88001H4.41818L4.25818 7.12001L4.33818 7.44001L4.01818 7.28001L3.77818 7.36001L3.85818 7.04001L3.61818 6.88001H3.93818L4.01818 6.64001ZM11.2982 5.92001L11.3782 6.16001H11.6982L11.4582 6.40001L11.5382 6.72001L11.2982 6.56001L11.0582 6.72001L11.1382 6.40001L10.8982 6.24001H11.2182L11.2982 5.92001ZM3.21818 5.92001L3.29818 6.16001H3.61818L3.45818 6.40001L3.53818 6.72001L3.21818 6.56001L2.97818 6.72001L3.05818 6.40001L2.81818 6.24001H3.13818L3.21818 5.92001ZM4.81818 5.92001L4.89818 6.16001H5.21818L4.97818 6.40001L5.05818 6.72001L4.81818 6.56001L4.57818 6.72001L4.65818 6.40001L4.41818 6.24001H4.73818L4.81818 5.92001ZM6.41818 5.92001L6.49818 6.16001H6.81818L6.65818 6.40001L6.73818 6.72001L6.41818 6.56001L6.17818 6.72001L6.25818 6.40001L6.01818 6.24001H6.33818L6.41818 5.92001ZM8.09818 5.92001L8.17818 6.16001H8.49818L8.25818 6.40001L8.33818 6.72001L8.09818 6.56001L7.85818 6.72001V6.40001L7.69818 6.24001H8.01818L8.09818 5.92001ZM9.69818 5.92001L9.77818 6.16001H10.0982L9.85818 6.40001L9.93818 6.72001L9.69818 6.56001L9.45818 6.72001V6.40001L9.21818 6.24001H9.53818L9.69818 5.92001ZM10.4982 6.64001L10.5782 6.88001H10.8982L10.6582 7.04001L10.7382 7.36001L10.4982 7.20001L10.2582 7.36001L10.3382 7.04001L10.0982 6.88001H10.4182L10.4982 6.64001ZM8.89818 6.64001L8.97818 6.88001H9.29818L9.05818 7.04001L9.13818 7.36001L8.89818 7.20001L8.65818 7.36001L8.73818 7.12001L8.49818 6.88001H8.81818L8.89818 6.64001ZM7.21818 6.64001L7.29818 6.88001H7.61818L7.45818 7.12001L7.53818 7.44001L7.21818 7.28001L6.97818 7.36001L7.05818 7.04001L6.81818 6.88001H7.13818L7.21818 6.64001ZM5.61818 6.64001L5.69818 6.88001H6.01818L5.77818 7.12001L5.85818 7.44001L5.61818 7.28001L5.37818 7.36001L5.45818 7.04001L5.21818 6.88001H5.53818L5.61818 6.64001ZM4.01818 5.28001L4.09818 5.52001H4.41818L4.25818 5.76001L4.33818 6.08001L4.01818 5.92001L3.77818 6.08001L3.85818 5.76001L3.61818 5.60001H3.93818L4.01818 5.28001ZM11.2982 4.56001L11.4582 4.80001H11.7782L11.5382 4.96001L11.6182 5.28001L11.3782 5.12001L11.1382 5.28001V5.04001L10.8982 4.88001H11.2182L11.2982 4.56001ZM3.21818 4.56001L3.37818 4.80001H3.69818L3.45818 5.04001L3.53818 5.36001L3.21818 5.20001L2.97818 5.36001L3.05818 5.04001L2.81818 4.88001L3.13818 4.80001L3.21818 4.56001ZM4.81818 4.56001L4.89818 4.80001H5.21818L4.97818 5.04001L5.05818 5.36001L4.81818 5.20001L4.57818 5.36001L4.65818 5.04001L4.41818 4.88001L4.73818 4.80001L4.81818 4.56001ZM6.41818 4.56001L6.57818 4.80001H6.89818L6.65818 5.04001L6.73818 5.36001L6.41818 5.20001L6.17818 5.36001L6.25818 5.04001L6.01818 4.88001L6.33818 4.80001L6.41818 4.56001ZM8.09818 4.56001L8.17818 4.80001H8.49818L8.25818 5.04001L8.33818 5.36001L8.09818 5.20001L7.85818 5.36001L7.93818 5.04001L7.69818 4.88001L7.93818 4.80001L8.09818 4.56001ZM9.69818 4.56001L9.77818 4.80001H10.0982L9.85818 4.96001L9.93818 5.28001L9.69818 5.12001L9.45818 5.28001L9.53818 4.96001L9.29818 4.80001H9.53818L9.69818 4.56001ZM10.4982 5.28001L10.5782 5.52001H10.8982L10.6582 5.68001L10.7382 6.00001L10.4982 5.84001L10.2582 6.00001L10.3382 5.68001L10.0182 5.60001H10.3382L10.4982 5.28001ZM8.89818 5.28001L8.97818 5.52001H9.29818L9.05818 5.68001L9.13818 6.00001L8.89818 5.84001L8.65818 6.08001L8.73818 5.76001L8.49818 5.60001H8.81818L8.89818 5.28001ZM7.21818 5.28001L7.29818 5.52001H7.61818L7.45818 5.76001L7.53818 6.08001L7.21818 5.92001L6.97818 6.08001L7.05818 5.76001L6.81818 5.60001H7.13818L7.21818 5.28001ZM5.61818 5.28001L5.69818 5.52001H6.01818L5.77818 5.76001L5.85818 6.08001L5.61818 5.92001L5.37818 6.08001L5.45818 5.76001L5.21818 5.60001H5.53818L5.61818 5.28001ZM4.09818 4.00001L4.17818 4.24001H4.49818L4.25818 4.48001L4.33818 4.80001L4.09818 4.64001L3.77818 4.72001L3.85818 4.40001L3.61818 4.24001H3.93818L4.09818 4.00001ZM11.3782 3.28001L11.4582 3.52001H11.7782L11.5382 3.68001L11.6182 4.00001L11.3782 3.84001L11.1382 4.00001V3.76001L10.8982 3.60001H11.2182L11.3782 3.28001ZM3.29818 3.28001L3.37818 3.52001H3.69818L3.45818 3.76001L3.53818 4.08001L3.29818 3.92001L2.97818 4.08001L3.05818 3.76001L2.81818 3.60001H3.13818L3.29818 3.28001ZM4.81818 3.28001L4.89818 3.52001H5.21818L5.05818 3.76001L5.13818 4.08001L4.81818 3.92001L4.57818 4.08001L4.65818 3.76001L4.41818 3.60001H4.73818L4.81818 3.28001ZM6.49818 3.28001L6.57818 3.52001H6.89818L6.65818 3.76001L6.73818 4.08001L6.49818 3.92001L6.25818 4.08001L6.33818 3.76001L6.09818 3.60001H6.41818L6.49818 3.28001ZM8.09818 3.28001L8.17818 3.52001H8.49818L8.33818 3.76001L8.41818 4.08001L8.09818 3.92001L7.85818 4.08001L7.93818 3.76001L7.69818 3.60001H8.01818L8.09818 3.28001ZM9.69818 3.28001L9.77818 3.52001H10.0982L9.85818 3.68001L9.93818 4.00001L9.69818 3.84001L9.45818 4.00001L9.53818 3.76001L9.29818 3.60001H9.61818L9.69818 3.28001ZM10.4982 4.00001L10.5782 4.24001H10.8982L10.6582 4.40001L10.7382 4.72001L10.4982 4.56001L10.2582 4.72001L10.3382 4.48001L10.0982 4.32001H10.4182L10.4982 4.00001ZM8.89818 4.00001L8.97818 4.24001H9.29818L9.05818 4.40001L9.13818 4.72001L8.89818 4.56001L8.65818 4.72001L8.73818 4.48001L8.49818 4.24001H8.81818L8.89818 4.00001ZM7.29818 4.00001L7.37818 4.24001H7.69818L7.45818 4.48001L7.53818 4.80001L7.29818 4.64001L7.05818 4.72001L7.13818 4.48001L6.89818 4.24001H7.21818L7.29818 4.00001ZM5.61818 4.00001L5.69818 4.24001H6.01818L5.85818 4.48001L5.93818 4.80001L5.61818 4.64001L5.37818 4.72001L5.45818 4.40001L5.21818 4.24001H5.53818L5.61818 4.00001ZM11.3782 1.92001L11.4582 2.16001H11.7782L11.5382 2.40001L11.6182 2.72001L11.3782 2.56001L11.1382 2.72001V2.40001L10.8982 2.24001H11.2182L11.3782 1.92001ZM3.29818 1.92001L3.37818 2.16001H3.69818L3.45818 2.40001L3.53818 2.72001L3.29818 2.56001L3.05818 2.72001V2.40001L2.89818 2.16001H3.21818L3.29818 1.92001ZM4.89818 1.92001L4.97818 2.16001H5.29818L5.05818 2.40001L5.13818 2.72001L4.89818 2.56001L4.57818 2.72001L4.65818 2.40001L4.41818 2.16001H4.73818L4.89818 1.92001ZM6.49818 1.92001L6.57818 2.16001H6.89818L6.65818 2.40001L6.73818 2.72001L6.49818 2.56001L6.25818 2.72001L6.33818 2.40001L6.09818 2.16001H6.41818L6.49818 1.92001ZM8.17818 1.92001L8.25818 2.16001H8.57818L8.33818 2.40001L8.41818 2.72001L8.17818 2.56001L7.85818 2.72001L7.93818 2.40001L7.69818 2.16001H8.01818L8.17818 1.92001ZM9.69818 1.92001L9.77818 2.16001H10.0982L9.93818 2.40001L10.0182 2.72001L9.77818 2.56001L9.53818 2.72001V2.40001L9.29818 2.24001H9.61818L9.69818 1.92001ZM10.4982 2.64001L10.5782 2.88001H10.8982L10.6582 3.04001L10.7382 3.36001L10.4982 3.20001L10.2582 3.36001L10.3382 3.12001L10.0982 2.96001H10.4182L10.4982 2.64001ZM8.97818 2.64001L9.05818 2.88001H9.37818L9.13818 3.04001L9.21818 3.36001L8.97818 3.20001L8.65818 3.36001L8.73818 3.12001L8.49818 2.88001H8.81818L8.97818 2.64001ZM7.29818 2.64001L7.37818 2.88001H7.69818L7.53818 3.12001L7.61818 3.44001L7.29818 3.20001L7.05818 3.36001L7.13818 3.12001L6.89818 2.88001H7.21818L7.29818 2.64001Z"
        fill="white"
      />
    </svg>
  );
};

export const MexFlag = () => {
  return (
    <svg
      width="25"
      height="22"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className="iconify iconify--twemoji"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fill="#006847"
        d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h7V5H4z"
      ></path>
      <path
        fill="#CE1126"
        d="M32 5h-7v26h7a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"
      ></path>
      <path fill="#EEE" d="M11 5h14v26H11z"></path>
      <path
        fill="#A6D388"
        d="M23 18a5 5 0 1 1-10 0h-1a6 6 0 0 0 12 0h-1z"
      ></path>
      <path
        d="M13.543 20.269a.498.498 0 0 0-.673-.218a.5.5 0 0 0-.219.673c.09.177.189.35.296.516v.001l.004.006v.001l.008.011v.001l.003.006l.001.002l.004.005v.001l.003.005v.002l.003.005l.001.002l.003.005l.001.002l.003.004l.002.003l.002.003l.001.003l.003.005l.001.001l.002.003l.003.006l.001.002l.003.005l.001.002l.007.01v.001l.005.007v.001c.052.077.105.151.161.226a.497.497 0 0 0 .697.101a.499.499 0 0 0 .103-.699a5.96 5.96 0 0 1-.43-.71zm-.497-1.582a5.282 5.282 0 0 1-.046-.833a.5.5 0 0 0-.485-.514l-.036.001a.5.5 0 0 0-.478.485a8.061 8.061 0 0 0-.001.311v.09l.001.005v.028l.001.003l-.001.002v.003l.001.002v.029l.001.003v.011l.001.019l.001.009v.011c.009.16.025.319.046.477a.5.5 0 0 0 .562.425a.503.503 0 0 0 .433-.567zm5.294 4.3l-.006.001l-.124.008a5.087 5.087 0 0 1-.71-.021a.5.5 0 0 0-.1.995l.125.011l.004.001l.002-.001l.003.001h.002l.006.001h.006l.003.001h.001l.006-.001l.003.001h.005l.006.001l.005.001h.013l.006.001h.013c.152.01.305.015.459.012h.039l.007-.001l.006.001h.015l.005-.001h.019l.006-.001h.001l.005.001l.001-.001l.006.001h.001l.005-.001h.008l.006-.001h.006l.001.001l.006-.001h.007l.005-.001h.02l.005-.001h.004l.004-.001l.004.001h.005l.004-.001h.005c.042-.001.085-.005.127-.007a.494.494 0 0 0 .453-.526a.493.493 0 0 0-.514-.473zm-2.439-.448a5.07 5.07 0 0 1-.724-.411a.495.495 0 0 0-.303-.087a.5.5 0 0 0-.263.911l.001.001l.006.003l.006.006l.006.004l.006.005c.266.181.548.34.842.476a.498.498 0 0 0 .663-.243a.498.498 0 0 0-.24-.665zm5.03-.398a.498.498 0 0 0-.248.08a5.142 5.142 0 0 1-.734.387a.498.498 0 0 0 .213.96a.528.528 0 0 0 .173-.038l.134-.06h.002l.006-.004l.002-.001l.004-.002h.004l.004-.002l.002-.002l.006-.001l.002-.002l.003-.002l.005-.002l.003-.001l.005-.002l.002-.001l.005-.002l.002-.001c.003-.002.003-.003.005-.003l.002-.001l.006-.003h.002l.006-.003l.006-.003l.002-.001l.005-.003l.002-.001l.006-.003l.001-.001l.007-.001l.007-.004l.002-.001l.004-.003h.002l.006-.004l.008-.002l.006-.004h.001l.007-.004l.001-.001l.014-.006l.007-.003l.014-.008l.008-.003l.006-.003h.001l.014-.008v-.001l.006-.002h.001l.022-.012l.007-.002l.014-.008l.007-.004h.001c.001-.001.003-.002.007-.002c.002-.003.004-.004.006-.005l.008-.004l.006-.003v-.001l.014-.006h.001l.007-.004l.001-.001l.005-.003h.001l.007-.004l.006-.003h.002l.006-.004v-.001l.007-.003l.001-.001l.006-.003v-.001l.006-.002l.002-.001l.004-.003l.003-.001l.005-.003l.002-.001l.005-.003l.002-.001l.006-.002c-.001-.001 0-.001.001-.001l.006-.003l.002-.001l.004-.003l.002-.001l.006-.003l.002-.001c0-.002.002-.002.004-.003l.003-.001l.004-.002l.003-.002l.004-.002l.003-.002l.003-.002l.003-.003l.005-.001l.004-.001l.002-.002l.004-.002l.004-.003l.002-.001l.004-.002l.004-.003l.003-.002c.002.001.003 0 .005-.001l.002-.002l.004-.002l.003-.002l.003-.002l.004-.002l.004-.003l.002-.001c.002-.001.006-.001.008-.003c-.002-.001-.002-.001 0-.001l.004-.002l.007-.005l.002-.001l.007-.003v-.001l.012-.006l.008-.005a.095.095 0 0 1 .02-.011h.001c.063-.038.128-.077.19-.117a.5.5 0 0 0 .152-.69a.554.554 0 0 0-.457-.225zm2.571-4.618l-.024.001a.5.5 0 0 0-.479.498c0 .277-.025.557-.072.829a.5.5 0 0 0 .987.168v-.005l.001-.002l.001-.002l-.001-.002l.001-.002v-.002l.001-.002v-.003l.001-.002v-.009c.002-.001.002-.003.002-.004v-.006a6.23 6.23 0 0 0 .052-.391l-.001-.001l.001-.003v-.001l.001-.004v-.011l.002-.003v-.001l-.001-.003v-.002l.001-.003v-.004l.002-.001l-.002-.003v-.004c.002-.001.002-.002.002-.003v-.019l.002-.003v-.001a6.22 6.22 0 0 0 .021-.495a.5.5 0 0 0-.498-.499zm-.443 2.696a.5.5 0 0 0-.68.196a4.853 4.853 0 0 1-.463.692a.5.5 0 0 0 .783.622c.116-.146.227-.299.33-.455c.002-.007.007-.014.011-.02l.001-.001l.004-.006v-.001l.004-.007c.002-.002.004-.004.004-.006l.001.001l.004-.006v-.001a.01.01 0 0 0 .003-.007l.002-.001l.004-.006v-.001c.002-.001.002-.003.003-.005l.001-.001l.004-.006l.001-.002l.002-.005l.003-.002l.002-.005h.002l.002-.006l.001-.002l.004-.004l.001-.002c.001-.002.001-.004.003-.005l.001-.003l.004-.003c0-.001 0-.002.002-.003v-.004l.003-.002l.003-.005l.001-.002l.003-.006l.002-.002l.002-.004l.002-.003c0-.001 0-.002.002-.003c0-.001 0-.002.002-.003l.003-.005l.001-.003l.002-.003l.002-.003c.002-.001.002-.002.002-.003c.002-.001.002-.002.002-.004l.002-.003l.003-.004l.003-.004v-.003l.002-.003l.003-.004l.003-.003v-.003l.004-.005v-.003c.002-.001.003-.002.003-.004l.002-.002l.002-.003l.003-.005l.002-.003v-.002l.004-.005c0-.001 0-.002.002-.003l.001-.003l.003-.004l.002-.004l.002-.003c.001-.001 0-.003.002-.004c0-.001 0-.002.002-.002l.002-.005l.002-.002l.002-.006l.002-.001l.002-.004l.002-.002l.002-.005l.002-.002l.002-.006c.002-.001 0-.002 0-.002l.004-.005l.001-.002l.004-.005v-.001l.003-.006l.002-.002l.002-.006v-.001l.005-.005l.003-.006v-.001l.004-.007l.002-.001l.025-.047a.498.498 0 0 0-.199-.672z"
        fill="#5C913B"
      ></path>
      <ellipse fill="#55ACEE" cx="18" cy="21" rx="3" ry="1"></ellipse>
      <ellipse fill="#FFCC4D" cx="18.5" cy="21" rx="1.5" ry="1"></ellipse>
      <path
        fill="#5C913B"
        d="M19.117 21.274a.503.503 0 0 1-.44-.739c.16-.294.328-.561.502-.795a10 10 0 0 1-.43.009c-.276 0-.528-.225-.528-.501s.195-.5.472-.5l.082.001c.296 0 .6-.018.872-.043a.49.49 0 0 1 .41.156c.014-.011.028-.022.043-.031c.1-.066.193-.119.28-.161a.49.49 0 0 1 .211-.094l.036-.007c.188-.061.32-.069.373-.069a.498.498 0 0 1 .477.647c-.082.266-.265.326-.586.39a1.2 1.2 0 0 0-.238.128a.507.507 0 0 1-.599-.034a.499.499 0 0 1-.002.614c-.17.217-.337.475-.496.768a.498.498 0 0 1-.439.261zm-1.42-1.589a.497.497 0 0 1-.066-.004a6.98 6.98 0 0 1-1.056-.221a.5.5 0 0 1-.337-.622l.006-.02l-.012.023a.5.5 0 0 1-.681.192a4.126 4.126 0 0 1-.907-.681a.5.5 0 0 1 .707-.707c.197.197.428.37.688.515a.5.5 0 0 1 .229.597a.5.5 0 0 1 .59-.256c.276.082.579.145.9.188a.5.5 0 0 1-.061.996zm-2.452-2.339c-.426 0-.977-.165-1.311-.559c-.512-.604-.813-1.379-.767-1.973c.012-.159-.143-.287-.295-.327c-.087-.023-.24-.037-.312.118a.25.25 0 0 1-.454-.21c.156-.339.506-.49.892-.392c.358.093.701.415.667.85c-.036.462.226 1.109.65 1.61c.223.264.611.371.875.381c.215.011.324-.038.347-.059c-.056-.133-.797-.523-1.113-.689c-.269-.141-.349-.335-.369-.472c-.067-.455.4-.916.852-1.36c.159-.157.31-.305.392-.414c.093-.123.078-.205.06-.256c-.069-.187-.368-.372-.728-.452c-.333-.074-.558-.235-.668-.479c-.145-.321-.068-.741.234-1.285a.25.25 0 1 1 .437.243c-.285.512-.257.744-.215.837c.042.092.149.157.32.195c.423.094.932.345 1.088.767c.089.241.044.501-.128.73c-.104.139-.268.3-.441.471c-.258.254-.739.727-.708.931c.006.042.061.079.107.102c.751.394 1.25.679 1.352 1.028a.456.456 0 0 1-.042.359c-.097.169-.299.273-.585.299c-.043.004-.09.006-.137.006z"
      ></path>
      <ellipse fill="#FFCC4D" cx="19.5" cy="18" rx=".5" ry="1"></ellipse>
      <path
        fill="#FFCC4D"
        d="M17.292 17.188c0 .288-.345.521-.771.521c-.425 0-.771-.233-.771-.521s.345-.521.771-.521c.425 0 .771.233.771.521zm-1.187-4.627c.05.212-.227.46-.619.553c-.392.093-.75-.004-.801-.216c-.05-.213.227-.461.618-.554c.393-.092.752.004.802.217z"
      ></path>
      <path
        fill="#C1694F"
        d="M22.533 17.955c.09.07.243-.729.22-.978c0-.017-.029-.546.083-.924c.069-.128.073-1.083-.033-1.334c.084-.007.185-.034.197-.136c-.388.143-.479-.817-.852-1.369c-.362-.553-.811-.875-1.28-1.211a.979.979 0 0 1 .162-.27c-.575.288-1.471-.755-2.795-.677c-.297.029-.438.047-.514.229c-.247.02-.498.076-.498.401c0 .078.071.22.229.221c.216.063.392.014.539.316l.039.312s-.193-.247-.299-.286l.065-.133c-.1-.058-.277-.011-.277-.011s-.385-.18-.694-.132l-.06-.25c-.054.154-.175.146-.192.291c-.034-.104-.079-.233-.111-.337c-.109.148-.077.308-.116.462c-.042.036-.128.037-.15-.062c-.011-.122-.026-.133-.026-.278c-.078.137-.172.204-.203.439l-.083-.26c.003.307-.261.49-.511.707c-.071.13.011.131.017.198l.132.066l.237-.017c.039.049.007.053.11.084c.276.077.62-.254.89.267c-.124.104-.249.347-.209.393c.05 0-.1.07.102.006c-.21.204-.352.473-.352.489c-.024.058.084-.008.062.097l.05-.006c-.479.518-.016 1.075-.067 1.374c.08.129.09-.003.19-.016c.084.368.326.591.474.882l-.312.003c.007.138.132.269.231.39l-.209.066a1.128 1.128 0 0 0-.352.274c-.069.168.333.208.527.238l-.007.203c.303.029.653-.061.653-.078l.076-.059l.171.094c.057 0 .146-.228.105-.403c.11.131.214.342.324.474l.103-.014c.094.149.223.297.317.446l.105.04c.061-.021.113-.028.146-.148l.048.084l.166-.114l.116-.023l.087.142c.051-.019.101-.13.104-.248c.052.103.066.095.104.122l.077-.162l.415.388l.314.018c.112.076.419.124.471.001c.252.108.549-.014.534-.134c.232.092.589.03.589.015c.043-.005.153-.113.049-.194c-.767-.534-1.904-1.418-2.343-1.631c0-.158-.119-.727-.247-.883l.104-.174c.299.279.407.252.566.296c.17.135.229.34.399.527l.152.028a2.583 2.583 0 0 0-.554-.873c.164.082.436.301.618.46c.12.201.155.361.265.613c.08.051.162.238.151.083c-.019-.291-.224-.752-.224-.785c.326.258.322.66.421.905c.083.124.125.29.161.251l-.096-.756l-.056-.277c.241.139.327.669.44 1.305c0 .101.041.212.035.277c.052.064.111.241.11.136c0 0 0-1.034-.071-1.271c-.018-.127.03-.333.03-.333c.088.429.182.894.271 1.322v.315l.132.133c.025-.26.055-.518.081-.776l-.099-.925v-.264c-.002-.093.085-.076.14.03c.013.227.013.404.022.63c.039.258.066.447.085.776c.011.266.023.904.079.893z"
      ></path>
    </svg>
  );
};

export const AddIcon = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor: "pointer" }}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="green"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 5v14m-7-7h14"
        stroke="green"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const OpenSidebarIcon = ({ color }) => {
  const { isSideOpen, openSideBar } = useAuth();
  return (
    <div>
      {!isSideOpen ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          className="opensidebar"
          onClick={openSideBar}
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M14.4 0H2.6C1.5 0 0.5 1 0.5 2.1V13.9C0.5 15 1.5 16 2.6 16H14.4C15.6 16 16.5 15 16.5 13.9V2.1C16.5 1 15.5 0 14.4 0ZM7 12.4C7 13.5 6.1 14.5 4.9 14.5H4.3C3.2 14.5 2.2 13.5 2.2 12.4V3.6C2.2 2.5 3.2 1.5 4.3 1.5H4.9C6 1.5 7 2.5 7 3.6V12.4ZM14.8 8.2V8.3C14.8 8.4 14.7 8.5 14.6 8.6L12.2 11C12 11.2 11.7 11.3 11.5 11.3C11.3 11.3 11 11.2 10.8 11C10.4 10.6 10.4 10 10.8 9.6L11.4 9H9C8.5 9 8 8.5 8 8C8 7.5 8.5 7 9 7H11.4L10.8 6.4C10.4 6 10.4 5.4 10.8 5C11.2 4.6 11.8 4.6 12.2 5L14.5 7.3C14.6 7.4 14.7 7.5 14.7 7.6V7.7C14.8 7.9 14.8 8.1 14.8 8.2Z"
            fill={color}
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          onClick={openSideBar}
          className="opensidebar"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M2.91818 0H14.7182C15.8182 0 16.8182 1 16.8182 2.1V13.9C16.8182 15 15.8182 16 14.7182 16H2.91818C1.71818 16 0.818176 15 0.818176 13.9V2.1C0.818176 1 1.81818 0 2.91818 0ZM10.3182 12.4C10.3182 13.5 11.2182 14.5 12.4182 14.5H13.0182C14.1182 14.5 15.1182 13.5 15.1182 12.4V3.6C15.1182 2.5 14.1182 1.5 13.0182 1.5H12.4182C11.3182 1.5 10.3182 2.5 10.3182 3.6V12.4ZM2.51818 8.2V8.3C2.51818 8.4 2.61818 8.5 2.71818 8.6L5.11818 11C5.31818 11.2 5.61818 11.3 5.81818 11.3C6.01818 11.3 6.31818 11.2 6.51818 11C6.91818 10.6 6.91818 10 6.51818 9.6L5.91818 9H8.31818C8.81818 9 9.31818 8.5 9.31818 8C9.31818 7.5 8.81818 7 8.31818 7H5.91818L6.51818 6.4C6.91818 6 6.91818 5.4 6.51818 5C6.11818 4.6 5.51818 4.6 5.11818 5L2.81818 7.3C2.71818 7.4 2.61818 7.5 2.61818 7.6V7.7C2.51818 7.9 2.51818 8.1 2.51818 8.2Z"
            fill={color}
          />
        </svg>
      )}
    </div>
  );
};

export const OverviewIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="overview icon 1">
        <g id="Group">
          <path
            id="Vector"
            d="M8.4 2H2.9C2.4 2 2 2.4 2 2.9V5.6C2 6 2.4 6.4 2.9 6.4H8.4C8.9 6.4 9.3 6 9.3 5.5V2.9C9.3 2.4 8.9 2 8.4 2Z"
            fill={color}
          />
          <path
            id="Vector_2"
            d="M2.9 7.20001H8.4C8.9 7.20001 9.3 7.60001 9.3 8.10001V17.2C9.3 17.7 8.9 18.1 8.4 18.1H2.9C2.4 18 2 17.6 2 17.1V8.10001C2 7.60001 2.4 7.20001 2.9 7.20001Z"
            fill={color}
          />
          <path
            id="Vector_3"
            d="M17.1 13.6H11.6C11.1 13.6 10.7 14 10.7 14.5V17.2C10.7 17.7 11.1 18.1 11.6 18.1H17.1C17.6 18.1 18 17.7 18 17.2V14.5C18 14 17.6 13.6 17.1 13.6Z"
            fill={color}
          />
          <path
            id="Vector_4"
            d="M11.6 2H17.1C17.6 2 18 2.4 18 2.9V12C18 12.5 17.6 12.9 17.1 12.9H11.6C11.1 12.9 10.7 12.5 10.7 12V2.9C10.7 2.4 11.1 2 11.6 2Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export const DriverWheel = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.8089e-07 7.9975C0.00166725 3.58667 3.58833 0 7.99917 0C12.415 0 16.005 3.59333 16 8.00917C15.995 12.4183 12.4033 16.0033 7.99333 16C3.58333 15.9967 -0.00166609 12.4075 5.8089e-07 7.9975ZM8.26833 1.16C6.7175 1.16917 5.52833 1.49417 4.43833 2.16417C3.2025 2.92417 2.29833 3.97583 1.71583 5.30333C1.59583 5.57667 1.63083 5.835 1.82333 6.06417C2.005 6.28083 2.24667 6.33083 2.51917 6.31417C3.415 6.26083 4.31167 6.2125 5.20833 6.16917C5.51083 6.15417 5.77083 6.04833 6.00083 5.85667C7.21333 4.84333 8.83167 4.84833 10.045 5.87C10.2325 6.02833 10.4458 6.12917 10.69 6.15C10.9367 6.17083 11.185 6.17583 11.4325 6.19C12.1558 6.23167 12.8792 6.28167 13.6033 6.31333C14.145 6.33667 14.4967 5.80667 14.2842 5.3075C13.2208 2.80417 10.7192 1.155 8.2675 1.15917L8.26833 1.16ZM1.25667 9.08667C1.26 9.115 1.26167 9.17667 1.27333 9.23583C1.53917 10.6458 2.18 11.8583 3.19917 12.8683C3.9 13.5625 4.7175 14.0775 5.64167 14.4208C6.15583 14.6117 6.69083 14.2042 6.61417 13.68C6.4075 12.2667 5.81083 11.0442 4.81333 10.0208C4.08583 9.275 3.22417 8.7375 2.23917 8.39917C1.74333 8.22833 1.26083 8.55333 1.2575 9.08667H1.25667ZM14.7392 9.23417C14.7525 8.58833 14.2608 8.21833 13.785 8.39417C11.3317 9.3 9.85833 11.0375 9.40333 13.6183C9.29667 14.2242 9.815 14.63 10.39 14.405C12.3508 13.6375 13.7075 12.2683 14.4392 10.2925C14.5825 9.905 14.6658 9.495 14.7392 9.23333V9.23417ZM6.70583 8.1525C6.70583 8.86667 7.28167 9.445 7.99583 9.44833C8.71167 9.4525 9.295 8.86667 9.29417 8.14667C9.29333 7.42583 8.72417 6.855 8.00583 6.8525C7.2875 6.85 6.705 7.4325 6.70583 8.1525Z"
        fill={color}
      />
    </svg>
  );
};

export const PersonnelIcon = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.588 0 0 3.588 0 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 2.5c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 11c-2.485 0-4.657-1.343-5.829-3.5.01-.805.526-1.541 1.543-1.982 1.462-.61 3.142-.517 4.286-.5 1.144-.017 2.824-.11 4.286.5 1.017.441 1.533 1.177 1.543 1.982C12.657 12.157 10.485 13.5 8 13.5z"
        fill={color}
      />
    </svg>
  );
};

export const ReportsIcon = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.645 0H2.35417C1.05417 0 0 1.05417 0 2.355V13.645C0 14.9458 1.05417 16 2.35417 16H13.645C14.945 16 16 14.9458 16 13.645V2.355C16 1.05417 14.945 0 13.645 0ZM4.95833 12.3C4.95833 12.8292 4.52917 13.2583 4 13.2583C3.47083 13.2583 3.04167 12.8292 3.04167 12.3V8.41C3.04167 7.88 3.47083 7.45167 4 7.45167C4.52917 7.45167 4.95833 7.88 4.95833 8.41V12.3ZM8.95833 12.3C8.95833 12.8292 8.52917 13.2583 8 13.2583C7.47083 13.2583 7.04167 12.8292 7.04167 12.3V3.01833C7.04167 2.48917 7.47 2.06 8 2.06C8.53 2.06 8.95833 2.48917 8.95833 3.01833V12.3ZM12.9583 12.3C12.9583 12.8292 12.5292 13.2583 12 13.2583C11.4708 13.2583 11.0417 12.8292 11.0417 12.3V5.52C11.0417 4.99083 11.4708 4.56167 12 4.56167C12.5292 4.56167 12.9583 4.99083 12.9583 5.52V12.3Z"
        fill={color}
      />
    </svg>
  );
};

export const BacklogIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill={color}
    >
      <path
        d="M6.10906 2V6H3.70906C3.30906 6 2.90906 5.6 2.90906 5.2V4.2C2.90906 3 3.90906 2 5.00906 2H6.10906Z"
        fill="white"
      />
      <path
        d="M18.9091 4.1V5.1C18.9091 5.6 18.5091 6 18.1091 6H8.10907V2H16.8091C17.9091 2 18.9091 3 18.9091 4.1Z"
        fill="white"
      />
      <path
        d="M6.10906 8V12H3.70906C3.30906 12 2.90906 11.6 2.90906 11.2V8.8C2.90906 8.4 3.30906 8 3.70906 8H6.10906Z"
        fill="white"
      />
      <path
        d="M18.9091 8.8V11.1C18.9091 11.6 18.5091 11.9 18.1091 11.9H8.10907V8H18.1091C18.5091 8 18.9091 8.4 18.9091 8.8Z"
        fill="white"
      />
      <path
        d="M6.10906 14V18H5.10906C3.90906 18 2.90906 17 2.90906 15.9V14.9C2.90906 14.4 3.30906 14 3.70906 14H6.10906Z"
        fill="white"
      />
      <path
        d="M18.9091 14.8V15.8C18.9091 17 17.9091 17.9 16.8091 17.9H8.10907V13.9H18.1091C18.5091 14 18.9091 14.4 18.9091 14.8Z"
        fill="white"
      />
    </svg>
  );
};

export const InventoryIcon = ({ color }) => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M108 41.4V96C108 102.6 102.6 108 96 108H24C17.4 108 12 102.6 12 96V41.4C12 34.8 17.4 29.4 24 29.4H27.6C27.6 40.2 36.6 49.2 47.4 49.2H72.6C83.4 49.2 92.4 40.2 92.4 29.4H96C102.6 29.4 108 34.8 108 41.4Z"
        fill={color}
      />
      <path
        d="M80.4001 24V29.4C80.4001 33.6 76.8001 37.2 72.6001 37.2H47.4001C43.2001 37.2 39.6001 33.6 39.6001 29.4V24C39.6001 19.8 43.2001 16.2 47.4001 16.2H51.0001C51.6001 13.8 54.0001 12 56.4001 12H63.6001C66.6001 12 68.4001 13.8 69.0001 16.2H72.6001C76.8001 16.2 80.4001 19.8 80.4001 24Z"
        fill={color} 
      />
    </svg>
  );
};

export const LogoutIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="log out icon 1">
        <g id="Group">
          <path
            id="Vector"
            d="M12.4 14.3C12.4 13.9 12.1 13.5 11.6 13.5C11.2 13.5 10.8 13.9 10.8 14.3C10.8 15.5 9.9 16.4 8.7 16.4H5.6C4.5 16.4 3.5 15.4 3.5 14.3V5.7C3.5 4.5 4.4 3.6 5.6 3.6H8.8C9.9 3.6 10.9 4.6 10.9 5.7C10.9 6.1 11.2 6.5 11.7 6.5C12.1 6.5 12.5 6.1 12.5 5.7C12.5 3.6 10.9 2 8.9 2H5.6C3.6 2 2 3.7 2 5.7V14.2C2 16.3 3.6 18 5.6 18H8.8C10.7 18 12.4 16.3 12.4 14.3Z"
            fill={color}
          />
          <path
            id="Vector_2"
            d="M13.6 6.89999C13.3 7.19999 13.4 7.69999 13.7 7.99999L15.1 9.19999H7.20002C6.80002 9.19999 6.40002 9.59999 6.40002 9.99999C6.40002 10.4 6.70002 10.8 7.20002 10.8H15.1L13.7 12C13.5 12.2 13.4 12.4 13.4 12.6C13.4 12.8 13.5 13 13.6 13.1C13.9 13.4 14.3 13.5 14.7 13.2L17.8 10.6C17.8 10.6 17.9 10.6 17.9 10.5L18 10.4V10.3V10.2C18 10.2 18 10.2 18 10.1V9.99999V9.89999V9.79999C18 9.79999 18 9.69999 17.9 9.69999L17.8 9.59999L14.7 6.99999C14.3 6.49999 13.8 6.49999 13.6 6.89999Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export const Opensidebar_icon = ({ color }) => {
  const [icon, setIcon] = useState(true);
  return (
    <div>
      {icon ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          className="opensidebar"
          onClick={() => setIcon(!icon)}
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M14.4 0H2.6C1.5 0 0.5 1 0.5 2.1V13.9C0.5 15 1.5 16 2.6 16H14.4C15.6 16 16.5 15 16.5 13.9V2.1C16.5 1 15.5 0 14.4 0ZM7 12.4C7 13.5 6.1 14.5 4.9 14.5H4.3C3.2 14.5 2.2 13.5 2.2 12.4V3.6C2.2 2.5 3.2 1.5 4.3 1.5H4.9C6 1.5 7 2.5 7 3.6V12.4ZM14.8 8.2V8.3C14.8 8.4 14.7 8.5 14.6 8.6L12.2 11C12 11.2 11.7 11.3 11.5 11.3C11.3 11.3 11 11.2 10.8 11C10.4 10.6 10.4 10 10.8 9.6L11.4 9H9C8.5 9 8 8.5 8 8C8 7.5 8.5 7 9 7H11.4L10.8 6.4C10.4 6 10.4 5.4 10.8 5C11.2 4.6 11.8 4.6 12.2 5L14.5 7.3C14.6 7.4 14.7 7.5 14.7 7.6V7.7C14.8 7.9 14.8 8.1 14.8 8.2Z"
            fill={color}
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          onClick={() => setIcon(!icon)}
          className="opensidebar"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M2.91818 0H14.7182C15.8182 0 16.8182 1 16.8182 2.1V13.9C16.8182 15 15.8182 16 14.7182 16H2.91818C1.71818 16 0.818176 15 0.818176 13.9V2.1C0.818176 1 1.81818 0 2.91818 0ZM10.3182 12.4C10.3182 13.5 11.2182 14.5 12.4182 14.5H13.0182C14.1182 14.5 15.1182 13.5 15.1182 12.4V3.6C15.1182 2.5 14.1182 1.5 13.0182 1.5H12.4182C11.3182 1.5 10.3182 2.5 10.3182 3.6V12.4ZM2.51818 8.2V8.3C2.51818 8.4 2.61818 8.5 2.71818 8.6L5.11818 11C5.31818 11.2 5.61818 11.3 5.81818 11.3C6.01818 11.3 6.31818 11.2 6.51818 11C6.91818 10.6 6.91818 10 6.51818 9.6L5.91818 9H8.31818C8.81818 9 9.31818 8.5 9.31818 8C9.31818 7.5 8.81818 7 8.31818 7H5.91818L6.51818 6.4C6.91818 6 6.91818 5.4 6.51818 5C6.11818 4.6 5.51818 4.6 5.11818 5L2.81818 7.3C2.71818 7.4 2.61818 7.5 2.61818 7.6V7.7C2.51818 7.9 2.51818 8.1 2.51818 8.2Z"
            fill={color}
          />
        </svg>
      )}
    </div>
  );
};

export const SettingsIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="settings icon 1">
        <g id="XMLID_1290_">
          <g id="XMLID_1291_">
            <path
              id="Vector"
              d="M5.1 2.6V3.5C4.8 3.6 4.5 3.8 4.2 4.1L3.4 3.8C3.3 3.8 3.1 3.8 3.1 3.9L2.5 5C2.4 5.1 2.5 5.3 2.5 5.3L3.1 5.9C3 6.2 3 6.6 2.9 7L2.2 7.3C2 7.4 2 7.5 2 7.7L2.3 8.9C2.3 9 2.4 9.1 2.6 9.1H3.4C3.6 9.4 3.8 9.7 4.1 10L3.8 10.8C3.8 10.9 3.8 11.1 3.9 11.1L5 11.8C5.1 11.9 5.3 11.8 5.3 11.8L5.9 11.2C6.3 11.3 6.6 11.4 7 11.4L7.3 12.2C7.4 12.3 7.5 12.4 7.6 12.4L8.8 12.1C8.9 12.1 9 12 9 11.8V10.9C9.3 10.7 9.7 10.5 9.9 10.2L10.7 10.5C10.8 10.5 11 10.5 11 10.4L11.7 9.3C11.8 9.2 11.7 9 11.7 9L11.1 8.4C11.2 8 11.3 7.7 11.3 7.3L12 6.9C12.1 6.8 12.2 6.7 12.2 6.6L11.9 5.4C11.9 5.3 11.8 5.2 11.6 5.2H10.8C10.6 4.9 10.4 4.6 10.1 4.3L10.4 3.5C10.4 3.4 10.4 3.2 10.3 3.2L9.2 2.5C9.1 2.4 8.9 2.5 8.9 2.5L8.3 3.1C8 3 7.6 3 7.2 3L6.9 2.2C6.8 2 6.7 2 6.5 2L5.3 2.3C5.2 2.3 5.1 2.4 5.1 2.6ZM9.5 6.6C9.8 7.9 9 9.3 7.6 9.6C6.3 9.8 5 9 4.7 7.7C4.4 6.3 5.2 5 6.5 4.7C7.9 4.4 9.2 5.2 9.5 6.6Z"
              fill={color}
            />
          </g>
          <g id="XMLID_1294_">
            <path
              id="Vector_2"
              d="M12.3 10.4V11C12.1 11.1 11.8 11.3 11.6 11.5L11 11.3C10.9 11.3 10.7 11.3 10.7 11.4L10.2 12.2C10.1 12.3 10.2 12.5 10.2 12.5L10.7 12.9C10.6 13.2 10.6 13.4 10.6 13.7L9.99999 14C9.89999 14.1 9.79999 14.2 9.79999 14.3L9.99999 15.3C9.99999 15.4 10.1 15.5 10.3 15.5H10.9C11 15.7 11.2 16 11.4 16.2L11.2 16.8C11.2 16.9 11.2 17.1 11.3 17.1L12.1 17.6C12.2 17.7 12.4 17.6 12.4 17.6L12.8 17.1C13.1 17.2 13.3 17.2 13.6 17.2L13.9 17.8C14 17.9 14.1 18 14.2 18L15.2 17.8C15.3 17.8 15.4 17.7 15.4 17.5V16.9C15.6 16.8 15.9 16.6 16.1 16.4L16.7 16.6C16.8 16.6 17 16.6 17 16.5L17.5 15.7C17.6 15.6 17.5 15.4 17.5 15.4L17 15C17.1 14.7 17.1 14.5 17.1 14.2L17.7 14C17.8 13.9 17.9 13.8 17.9 13.7L17.7 12.7C17.7 12.6 17.6 12.5 17.4 12.5H16.8C16.7 12.3 16.5 12 16.3 11.8L16.5 11.2C16.5 11.1 16.5 10.9 16.4 10.9L15.6 10.4C15.5 10.3 15.3 10.4 15.3 10.4L14.9 10.9C14.6 10.8 14.4 10.8 14.1 10.8L13.8 9.99999C13.7 9.89999 13.6 9.79999 13.5 9.79999L12.5 9.99999C12.4 10.1 12.3 10.2 12.3 10.4ZM15.7 13.5C15.9 14.5 15.3 15.5 14.3 15.7C13.3 15.9 12.3 15.3 12.1 14.3C11.9 13.3 12.5 12.3 13.5 12.1C14.5 11.9 15.5 12.5 15.7 13.5Z"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DownArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
    >
      <path
        d="M8.66265 1L4.80723 4.85542C4.71084 4.95181 4.56627 5 4.42169 5C4.27711 5 4.13253 4.95181 4.03615 4.85542L0.180723 1C-0.060241 0.759036 -0.060241 0.421687 0.180723 0.180723C0.421687 -0.060241 0.759036 -0.060241 1 0.180723L4.46988 3.6506L7.93976 0.180723C8.18072 -0.060241 8.51807 -0.060241 8.75904 0.180723C8.90361 0.421687 8.90361 0.807229 8.66265 1Z"
        fill="#393838"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.6765 14.105C16.1078 14.5357 16.1078 15.2248 15.6765 15.6555C15.504 15.8277 15.159 16 14.9003 16C14.6415 16 14.3828 15.9139 14.124 15.6555L8 9.5397L1.87601 15.6555C1.7035 15.8277 1.35849 16 1.09973 16C0.84097 16 0.58221 15.9139 0.32345 15.6555C-0.107817 15.2248 -0.107817 14.5357 0.32345 14.105L6.44744 7.98923L0.32345 1.87349C-0.107817 1.4428 -0.107817 0.753701 0.32345 0.323015C0.754717 -0.107672 1.44474 -0.107672 1.87601 0.323015L8 6.43876L14.124 0.323015C14.5553 -0.107672 15.2453 -0.107672 15.6765 0.323015C16.1078 0.753701 16.1078 1.4428 15.6765 1.87349L9.55256 7.98923L15.6765 14.105Z"
        fill="#393838"
      />
    </svg>
  );
};

export const TrailerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="577"
      height="116"
      viewBox="0 0 577 116"
      fill="none"
    >
      <path
        d="M571.151 114.566L5.64362 114.566C3.15753 114.566 1.07611 112.544 1.07611 110.003V5.99661C1.07611 3.51338 3.09967 1.43441 5.64362 1.43441L571.151 1.43441C573.637 1.43441 575.718 3.45564 575.718 5.99661V110.003C575.718 112.487 573.695 114.566 571.151 114.566Z"
        fill="#E6E7FF"
        stroke="#A19CD3"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckInIcon = ({ color }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check in icon 1">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M17.4 6.9C17 5.9 16.4 5.1 15.7 4.4C15 3.7 14.1 3.1 13.1 2.7C12.1 2.3 11.1 2.1 10 2.1C8.9 2.1 7.9 2.2 6.9 2.6C5.9 3 5.1 3.6 4.4 4.3C3.6 5.1 3 5.9 2.6 6.9C2.2 7.9 2 8.9 2 10C2 11.1 2.2 12.1 2.6 13.1C3 14.1 3.6 14.9 4.3 15.6C5 16.3 5.9 16.9 6.8 17.3C7.8 17.7 8.8 17.9 9.9 17.9C11 17.9 12 17.7 13 17.3C14 16.9 14.8 16.3 15.6 15.6C16.3 14.9 16.9 14 17.3 13.1C17.7 12.1 17.9 11.1 17.9 10C17.9 8.9 17.8 7.9 17.4 6.9ZM14 8.4L10.2 13C10 13.2 9.8 13.3 9.5 13.3C9.3 13.3 9 13.2 8.8 13L6.7 10.8C6.3 10.4 6.3 9.8 6.7 9.5C6.9 9.3 7.1 9.2 7.4 9.2C7.7 9.2 7.9 9.3 8.1 9.5L9.4 11L12.5 7.2C12.7 7 13 6.8 13.2 6.8C13.4 6.8 13.7 6.8 13.9 7C14.3 7.3 14.4 7.9 14 8.4Z"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PrinterIcon = ({ func }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="currentColor"
    onClick={func}
    style={{ cursor: "pointer" }}
  >
    <path d="M6 4v4H4a2 2 0 0 0-2 2v6h4v4h12v-4h4v-6a2 2 0 0 0-2-2h-2V4H6zm2 2h8v2H8V6zm-2 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4 2h8v6H8v-6z" />
  </svg>
);

export const WarningIcon = ({ message }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="orange"
    >
      <title>{message}</title>
      <path
        d="M1 21h22L12 2 1 21z"
        stroke="black"
        stroke-width="2"
        fill="orange"
      />
      <path
        d="M12 8v5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
      <circle cx="12" cy="17" r="1.5" fill="black" />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v1H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM0 5v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5H0zm2 2h2v2H2V7zm3 0h2v2H5V7zm3 0h2v2H8V7z" />
      </svg>
    </span>
  );
};

export const TrashIconCont = ({ onClick }) => {
  return (
    <>
      <div
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
        }}
        className="trash-icon-container"
      >
        <div onClick={onClick}>
          <TrashIcon />
        </div>
      </div>
    </>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="red"
    >
      <path d="M3 6l3 0 0 13c0 1.1 0.9 2 2 2l8 0c1.1 0 2-0.9 2-2l0-13 3 0 0-2-6 0-1-1-4 0-1 1-6 0 0 2zm5 0l8 0 0 13-8 0 0-13zm2 2 0 9 2 0 0-9-2 0zm4 0 0 9 2 0 0-9-2 0z" />
    </svg>
  );
};
export const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      className="upload-icon"
    >
      <path
        d="M43.6998 28.32V33.6C43.6998 34.08 43.6998 34.32 43.6998 34.8C43.6998 35.28 43.6998 35.52 43.4598 36C43.4598 36.24 43.4598 36.48 43.2198 36.72C42.2598 39.12 40.5798 41.28 38.1798 42.24C37.9398 42.48 37.4598 42.48 37.2198 42.72C36.9798 42.72 36.7398 42.72 36.4998 42.96C36.2598 42.96 36.0198 42.96 35.7798 43.2C35.7798 43.2 35.7798 43.2 35.5398 43.2C35.0598 43.2 34.8198 43.2 34.3398 43.2H14.8998C14.4198 43.2 13.9398 43.2 13.6998 43.2C13.6998 43.2 13.6998 43.2 13.4598 43.2C13.2198 43.2 12.9798 43.2 12.7398 42.96C12.4998 42.96 12.2598 42.96 12.0198 42.72C11.5398 42.72 11.2998 42.48 11.0598 42.24C9.13981 41.52 7.6998 40.08 6.4998 38.16C6.2598 37.68 6.0198 37.2 5.7798 36.48C5.7798 36.24 5.5398 36 5.5398 35.76C5.2998 35.28 5.2998 35.04 5.2998 34.56C5.2998 34.08 5.2998 33.84 5.2998 33.36V28.08C5.2998 26.64 6.4998 25.68 7.6998 25.68C8.8998 25.68 10.0998 26.88 10.0998 28.08V33.6C10.0998 36.24 12.2598 38.4 14.8998 38.4H34.0998C36.7398 38.4 38.8998 36.24 38.8998 33.6V28.32C38.8998 27.12 40.0998 25.92 41.2998 25.92C42.4998 25.92 43.6998 26.88 43.6998 28.32Z"
        fill="#5656B9"
      />
      <path
        d="M35.0599 15.36C35.0599 16.08 34.8199 16.56 34.3399 17.04C33.3799 18 31.9399 18 30.9799 17.04L26.8999 12.96V13.44L27.1399 30.48C27.3799 31.68 25.9399 33.12 24.7399 32.88C23.2999 32.88 22.0999 31.68 22.3399 30.48L22.0999 13.44V12.96L18.0199 17.28C17.0599 18.24 15.6199 18.24 14.6599 17.28C13.6999 16.32 13.6999 14.88 14.6599 13.92L18.7399 9.59999L22.5799 5.75999L22.8199 5.51999C23.7799 4.55999 25.2199 4.55999 26.1799 5.51999L27.1399 6.47999L30.2599 9.59999L34.3399 13.68C34.8199 14.16 35.2999 14.64 35.0599 15.36Z"
        fill="#5656B9"
      />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <path
        d="M24.4998 33.12C28.2111 33.12 31.2198 30.1113 31.2198 26.4C31.2198 22.6886 28.2111 19.68 24.4998 19.68C20.7884 19.68 17.7798 22.6886 17.7798 26.4C17.7798 30.1113 20.7884 33.12 24.4998 33.12Z"
        fill="#5656B9"
      />
      <path
        d="M40.0998 12.96H39.8598V11.76C39.8598 11.52 39.6198 11.52 39.6198 11.52H34.0998C33.8598 11.52 33.8598 11.76 33.8598 11.76V13.2H32.1798L30.9798 10.08C30.4998 9.12002 29.5398 8.40002 28.3398 8.40002H20.8998C19.6998 8.40002 18.4998 9.12002 18.2598 10.08L16.8198 12.96H8.89981C6.9798 12.96 5.2998 14.64 5.2998 16.56V36C5.2998 37.92 6.9798 39.6 8.89981 39.6H40.3398C42.2598 39.6 43.9398 37.92 43.9398 36V16.56C43.6998 14.64 42.0198 12.96 40.0998 12.96ZM8.89981 18C7.93981 18 7.45981 17.28 7.45981 16.56C7.45981 15.6 8.17981 15.12 8.89981 15.12C9.61981 15.12 10.3398 15.84 10.3398 16.56C10.3398 17.28 9.61981 18 8.89981 18ZM33.6198 30C33.1398 31.2 32.4198 32.16 31.4598 33.12C30.4998 34.08 29.5398 34.8 28.3398 35.28C27.1398 35.76 25.9398 36 24.4998 36C23.0598 36 21.8598 35.76 20.6598 35.28C19.4598 34.8 18.4998 34.08 17.5398 33.12C16.5798 32.16 15.8598 31.2 15.3798 30C14.8998 28.8 14.6598 27.6 14.6598 26.4C14.6598 24.96 14.8998 23.76 15.3798 22.56C15.8598 21.36 16.5798 20.4 17.5398 19.44C18.4998 18.48 19.4598 17.76 20.6598 17.28C21.8598 16.8 23.0598 16.56 24.4998 16.56C25.9398 16.56 27.1398 16.8 28.3398 17.28C29.5398 17.76 30.4998 18.48 31.4598 19.44C32.4198 20.4 33.1398 21.36 33.6198 22.56C34.0998 23.76 34.3398 24.96 34.3398 26.4C34.3398 27.6 34.0998 28.8 33.6198 30Z"
        fill="#5656B9"
      />
    </svg>
  );
};

export const CheckOutIcon = ({ color }) => {
  return (
    <svg
      className="checkout-icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check out icon 12">
        <path
          id="Vector"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_2"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_3"
          d="M15.9 2H4.1C3 2 2 3 2 4.1V15.9C2 17 3 18 4.1 18H15.9C17.1 18 18 17 18 15.9V4.1C18 3 17 2 15.9 2ZM13.7 12.2C14.1 12.6 14.1 13.2 13.7 13.6C13.5 13.8 13.2 14 13 14C12.8 14 12.5 13.9 12.3 13.7L10 11.4L7.8 13.6L7.7 13.7C7.5 13.9 7.2 14 7 14C6.7 14 6.5 13.9 6.3 13.7C5.9 13.3 5.9 12.7 6.3 12.3L8.6 10L6.3 7.8C6 7.4 6 6.7 6.3 6.3C6.7 5.9 7.3 5.9 7.7 6.3L10 8.6L12.2 6.4C12.6 6 13.2 6 13.6 6.4C14 6.8 14 7.4 13.6 7.8L11.4 10L13.7 12.2Z"
          fill={color}
        />
        <path
          id="Vector_4"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_5"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <g id="Group">
          <path
            id="Vector_6"
            d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
            fill="#fff"
          />
        </g>
        <path
          id="Vector_7"
          d="M7.7 13.8C7.6 13.8 7.6 13.8 7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const CheckOutTableIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check out icon 12">
        <path
          id="Vector"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_2"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_3"
          d="M15.9 2H4.1C3 2 2 3 2 4.1V15.9C2 17 3 18 4.1 18H15.9C17.1 18 18 17 18 15.9V4.1C18 3 17 2 15.9 2ZM13.7 12.2C14.1 12.6 14.1 13.2 13.7 13.6C13.5 13.8 13.2 14 13 14C12.8 14 12.5 13.9 12.3 13.7L10 11.4L7.8 13.6L7.7 13.7C7.5 13.9 7.2 14 7 14C6.7 14 6.5 13.9 6.3 13.7C5.9 13.3 5.9 12.7 6.3 12.3L8.6 10L6.3 7.8C6 7.4 6 6.7 6.3 6.3C6.7 5.9 7.3 5.9 7.7 6.3L10 8.6L12.2 6.4C12.6 6 13.2 6 13.6 6.4C14 6.8 14 7.4 13.6 7.8L11.4 10L13.7 12.2Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_4"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <path
          id="Vector_5"
          d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
          fill="#FF6E6E"
        />
        <g id="Group">
          <path
            id="Vector_6"
            d="M7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8V13.8Z"
            fill="white"
          />
        </g>
        <path
          id="Vector_7"
          d="M7.7 13.8C7.6 13.8 7.6 13.8 7.7 13.8C7.6 13.7 7.6 13.8 7.7 13.8Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const HamBurger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="32px"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 32 32"
      width="32px"
      fill="currentColor"
    >
      <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
    </svg>
  );
};

export const LeftArrowNav = ({ clickFunction }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onClick={clickFunction}
    >
      <path
        d="M10.5601 15.04L4.16006 8.64C4.00006 8.48 3.92006 8.24 3.92006 8C3.92006 7.76 4.00006 7.52 4.16006 7.36L10.5601 0.960004C10.9601 0.560004 11.5201 0.560004 11.9201 0.960004C12.3201 1.36 12.3201 1.92 11.9201 2.32L6.16006 8.08L11.9201 13.84C12.3201 14.24 12.3201 14.8 11.9201 15.2C11.5201 15.44 10.8801 15.44 10.5601 15.04Z"
        fill="#5656B9"
      />
    </svg>
  );
};

export const RightArrowNav = ({ clickFunction }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onClick={clickFunction}
    >
      <path
        d="M5.44009 0.959997L11.8401 7.36C12.0001 7.52 12.0801 7.76 12.0801 8C12.0801 8.24 12.0001 8.48 11.8401 8.64L5.44009 15.04C5.04009 15.44 4.48009 15.44 4.08009 15.04C3.68009 14.64 3.68009 14.08 4.08009 13.68L9.84009 7.92L4.08009 2.16C3.68009 1.76 3.68009 1.2 4.08009 0.799996C4.48009 0.559997 5.12009 0.559998 5.44009 0.959997Z"
        fill="#5656B9"
      />
    </svg>
  );
};

export const UpArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
    >
      <path
        d="M0.195015 4L4.05044 0.144578C4.14682 0.0481925 4.2914 0 4.43598 0C4.58056 0 4.72514 0.0481925 4.82152 0.144578L8.67694 4C8.91791 4.24096 8.91791 4.57831 8.67694 4.81928C8.43598 5.06024 8.09863 5.06024 7.85767 4.81928L4.38779 1.3494L0.917907 4.81928C0.676943 5.06024 0.339593 5.06024 0.098629 4.81928C-0.045949 4.57831 -0.045949 4.19277 0.195015 4Z"
        fill="#393838"
      />
    </svg>
  );
};

export const BacklogIcon2 = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4110_1338)">
        <path
          d="M11.1275 11.41H1.05333C0.471593 11.41 0 11.8816 0 12.4634V14.9467C0 15.5284 0.471593 16 1.05333 16H11.1275C11.7092 16 12.1808 15.5284 12.1808 14.9467V12.4634C12.1808 11.8816 11.7092 11.41 11.1275 11.41Z"
          fill={color}
        />
        <path
          d="M11.1275 5.70496H1.05333C0.471593 5.70496 0 6.17655 0 6.75829V9.24162C0 9.82336 0.471593 10.295 1.05333 10.295H11.1275C11.7092 10.295 12.1808 9.82336 12.1808 9.24162V6.75829C12.1808 6.17655 11.7092 5.70496 11.1275 5.70496Z"
          fill={color}
        />
        <path
          d="M14.9468 0H4.87267C4.29093 0 3.81934 0.471593 3.81934 1.05333V3.53667C3.81934 4.11841 4.29093 4.59 4.87267 4.59H14.9468C15.5286 4.59 16.0002 4.11841 16.0002 3.53667V1.05333C16.0002 0.471593 15.5286 0 14.9468 0Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4110_1338">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
